exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-groups-patientselectcard-style__select{position:relative;cursor:pointer;margin:-14px;padding:8px 32px;border-radius:6px;background-color:#d0532c;-webkit-transition:background-color .1s linear;-ms-transition:background-color .1s linear;transition:background-color .1s linear}div.nil-sa-groups-patientselectcard-style__select:hover{background-color:#ff7601}div.nil-sa-groups-patientselectcard-style__edit{position:absolute;display:inline-block;right:12px;bottom:12px;cursor:pointer}div.nil-sa-groups-patientselectcard-style__name{text-align:center;font-family:Lato;font-size:14px;font-style:normal;font-weight:600;line-height:normal;letter-spacing:.14px;color:#fff}div.nil-sa-groups-patientselectcard-style__icon{text-align:center;font-size:30px;margin-bottom:-5px}.nil-sa-groups-patientselectcard-style__selectIcon{margin:0 auto;filter:invert(1)}", ""]);

// exports
exports.locals = {
	"select": "nil-sa-groups-patientselectcard-style__select",
	"edit": "nil-sa-groups-patientselectcard-style__edit",
	"name": "nil-sa-groups-patientselectcard-style__name",
	"icon": "nil-sa-groups-patientselectcard-style__icon",
	"selectIcon": "nil-sa-groups-patientselectcard-style__selectIcon"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/groups/PatientSelectCard/style.less
// module id = 429
// module chunks = 0